<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/mediate' }"
        >管理后台</el-breadcrumb-item
      >
      <el-breadcrumb-item>诉讼服务指南</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索栏 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="输入标题" v-model="queryInfo.query"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getArticlesList">搜索</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="showAddDialog">添加</el-button>
        </el-col>
      </el-row>

      <!-- 诉讼服务列表 -->
      <el-table border stripe :data="articles">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <!-- <el-table-column label="发布日期" prop="add_time"></el-table-column> -->
        <el-table-column
          label="发布日期"
          prop="add_time"
          :formatter="dateFormat"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加or编辑文章弹出层 -->
    <el-dialog
      :visible.sync="dialogVisble"
      width="50%"
      @close="addOrEditDialogClosed"
    >
      <el-form
        ref="addOrEditFormRef"
        :model="addOrEditForm"
        :rules="addOrEditFormRules"
        label-width="80px"
      >
        <el-form-item label="标题">
          <el-input v-model="addOrEditForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <quill-editor v-model="addOrEditForm.content"></quill-editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisble = false">取 消</el-button>
        <el-button type="primary" @click="addOrEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "List",
  data() {
    return {
      // 控制添加or修改框显示与隐藏
      dialogVisble: false,
      // 添加或修改的表单数据
      addOrEditForm: {
        id: -1,
        title: "",
        content: "",
      },
      // 标识是添加还是编辑
      isEdit: false,
      //   表单验证规则对象
      addOrEditFormRules: {
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
      },
      //   文章列表
      articles: [],
      // 查询参数对象
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      // 总数据条数
      total: 0,
    };
  },
  created() {
    this.getArticlesList();
  },
  methods: {
    // 添加按钮弹出层
    showAddDialog() {
      this.dialogVisble = true;
    },
    // 关闭弹出层
    addOrEditDialogClosed() {
      this.$refs.addOrEditFormRef.resetFields();
      this.addOrEditForm.title="";
      this.addOrEditForm.content="";
    },
    // 弹层添加和修改按钮事件
    addOrEdit() {
      if (!this.isEdit) {
        this.addArticle();
      } else {
        this.editArticle();
      }
    },
    // 添加
    addArticle() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post("service", {
          title: this.addOrEditForm.title,
          content: this.addOrEditForm.content,
        });
        if (res.meta.status !== 201) {
          return this.$message.error("添加失败！");
        }
        this.$message.success("添加成功！");
        this.getArticlesList();
        this.dialogVisble = false;
      });
    },
    // 修改
    editArticle() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.put(
          `service/${this.addOrEditForm.id}`,
          {
            title: this.addOrEditForm.title,
            content: this.addOrEditForm.content,
          }
        );
        if (res.meta.status !== 200) {
          return this.$message.error("修改失败！");
        }
        this.$message.success("修改成功！");
        this.getArticlesList();
        this.dialogVisble = false;
      });
    },
    // 根据分页获取对应的文章列表
    async getArticlesList() {
      const { data: res } = await this.$http.get("service", {
        params: this.queryInfo,
      });

      if (res.meta.status !== 200) {
        return this.$message.error("获取文章列表失败！");
      }
      this.$message.success("获取文章列表成功！");
      console.log(res.data);
      this.articles = res.data.articles;
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getArticlesList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getArticlesList();
    },
    // 删除商品
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该文章, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      const { data: res } = await this.$http.delete(`service/${id}`);
      if (res.meta.status !== 200) {
        console.log(res.meta.msg);
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getArticlesList();
    },
    //时间格式化-S
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    showEditDialog(row) {
      this.dialogVisble = true;
      this.isEdit = true;
      this.addOrEditForm.id = row.id;
      this.addOrEditForm.title = row.title;
      this.addOrEditForm.content = row.content;
    },
  },
};
</script>
<style scoped>
</style>